@if (!showContact) {
  <div class="container">
    <div class="header">
      <div class="title">
        <span fiTranslation="ACTION_LINK_LEAD_HEADLINE_CONECT_LEAD"></span>
        - {{ contactDetails?.FirstName }} {{ contactDetails?.LastName }}
      </div>
      <button (click)="onClosePopup()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
        <span class="u-hidden-visually" fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
      </button>
    </div>
    <div class="description">
      <span fiTranslation="ACTION_LINK_LEAD_SELECT_CONTACT"></span> ID {{ this.leadDetails?.Number }}
    </div>
    <fi-input
      type="SELECT"
      placeholderKey="ACTION_LINK_LEAD_PLACEHOLDER"
      [options]="filteredData"
      [maxMenuHeight]="200"
      [selectedOptionsOrValues]="contactId"
      [enableSearch]="true"
      [hasError]="noContactIsSelected"
      [namePropertyPath]="getItemText"
      (onSearch)="onFilter($event)"
      (onChange)="contactId = +$event; noContactIsSelected = false;"
      >
    </fi-input>
    <button class="contact-form-toggle" (click)="toggleContact()">
      <mat-icon>
        {{ showContact ? 'remove' : 'add' }}
      </mat-icon>
      <span fiTranslation="BUTTON_LINK_LEAD_NEW_CONTACT"></span>
    </button>
    <div class="button-row">
      <button (click)="connectContact()">
        <img alt="Link" src="/assets/icons/new/link-light.svg">
        <span class="btn-title" fiTranslation="BUTTON_LINK_LEAD"></span>
      </button>
    </div>
  </div>
}


@if (showContact) {
  <div class="contact-container">
    <div class="header">
      <div>
        <span fiTranslation="ACTION_LINK_LEAD_HEADLINE_CONECT_LEAD"></span>
        - {{ contactDetails?.FirstName }} {{ contactDetails?.LastName }}
      </div>
      <fi-button
        variant="tertiary"
        tone="neutral"
        size="lg"
        [iconOnly]="true"
        (click)="onClosePopup()"
      >
        <mat-icon fiButtonIcon>close</mat-icon>
        <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
      </fi-button>
    </div>
    <div class="form-container"
      [class.private]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PRIVATE"
      [class.trade]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_TRADE"
      [class.planer]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PLANER"
      >
      <fi-contact-form [requestForm]="requestForm"
        [privacy]="{ contact: true, documented: true }"
        [contactForm]="contactForm"
        [isNewLeadForm]="false"
        [isLinkForm]="true"
        [showPrivate]="true">
      </fi-contact-form>
    </div>
    <div class="footer">
      <button (click)="onSubmit()">
        <span fiTranslation="REQUEST_DETAIL_CONNECT_BUTTON"></span>
      </button>
    </div>
  </div>
}

